const lang={
    en:{
        search:"Search",
        gptSearchPlaceholder:"What you wanna watch buddy"
    },
    hindi:{
        search:"खोज",
        gptSearchPlaceholder:"तुम क्या देखना चाहते हो दोस्त"
    },
     french:{
        search:"recherche",
        gptSearchPlaceholder:"Qu'est-ce que tu veux regarder mon pote ?"
    },
     spanish:{
        search:"buscar",
        gptSearchPlaceholder:"Lo que quieres ver amiga"
    },
     german:{
        search:"suchen",
        gptSearchPlaceholder:"Was willst du sehen, Kumpel"
    },
}
export default lang;